import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from 'general/components/OtherKeenComponents/KTBSButton';
import PropTypes from 'prop-types';

DialogUploadIdentifierInvalidDataView.propTypes = {
  excelBase64: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
};

const downloadExcelFromBase64 = (excelBase64, fileName = 'danh_sach_ma_dinh_danh_loi.xlsx') => {
  const binary = atob(excelBase64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([bytes], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  Utils.downloadFile(blob, fileName);
};

function DialogUploadIdentifierInvalidDataView({ excelBase64, onCancel }) {
  const handleDownload = () => {
    downloadExcelFromBase64(excelBase64);
  };

  return (
    <AgencySaleDialogView
      iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} alt="" />}
      title="Dữ liệu tải lên không hợp lệ"
      contentEl={
        <>
          Phát hiện dữ liệu trong danh sách tải lên không hợp lệ. Vui lòng tải xuống file để xem chi tiết các ô
          lỗi đã được{' '}
          <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>tô vàng</span>.
        </>
      }
      removeFooter
      isShowConfirmButton={false}
      onCancel={() => {}}
      onConfirm={() => {}}
      bodyEl={
        <div
          className="w-100"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 12,
            padding: '12px 16px',
            borderTop: `1px solid ${AppColors.gray[200]}`,
          }}
        >
          <KTBSButton
            color={KTBSButtonColor.light}
            title="Hủy bỏ"
            size={KTBSButtonSize.default}
            borderRadius={5}
            buttonTitleFontWeight="600"
            buttonTitleColor={AppColors.gray[800]}
            buttonTitleFontSize={14}
            onPress={onCancel}
            additionalClassName="w-100"
          />
          <KTBSButton
            color={KTBSButtonColor.success}
            title="Tải xuống file"
            size={KTBSButtonSize.default}
            borderRadius={5}
            buttonTitleFontWeight="600"
            buttonTitleColor="#fff"
            buttonTitleFontSize={13}
            onPress={handleDownload}
            iconElement={<i className="fa-regular fa-download" />}
            additionalClassName="w-100"
          />
        </div>
      }
    />
  );
}

export default DialogUploadIdentifierInvalidDataView;
